import { ObjectWithTranslation } from 'common/types/transformedRespTypes'
import { Status, CallAPIAction } from 'api/types'
import Actions from 'redux/actions'
import { RejectionReasonsListResponse } from 'api/evisaAPI/evisaAPI'

import { formatAlternativeObjectWithTranslationFromBE } from './skills'

type State = {
  data: ObjectWithTranslation[]
  cancellationStatus?: string
} & Status

const initialState = {
  data: [],

  isLoading: false,
  success: false,
  fail: false,
}

const convertResponseToState = (resp: RejectionReasonsListResponse) => ({
  data: resp.map(formatAlternativeObjectWithTranslationFromBE),
})

export default (
  state: State = initialState,
  action: CallAPIAction<
    Actions.GET_REJECTION_REASONS_LIST_ASYNC,
    Actions.GET_REJECTION_REASONS_LIST_SUCCESS,
    Actions.GET_REJECTION_REASONS_LIST_FAIL,
    RejectionReasonsListResponse
  >,
): State => {
  switch (action.type) {
    case Actions.GET_REJECTION_REASONS_LIST_ASYNC: {
      return {
        ...state,
        ...action.status,
      }
    }
    case Actions.GET_REJECTION_REASONS_LIST_SUCCESS: {
      const { payload } = action
      return {
        ...state,
        ...action.status,
        ...convertResponseToState(payload),
      }
    }
    case Actions.GET_REJECTION_REASONS_LIST_FAIL: {
      return {
        ...state,
        ...action.status,
      }
    }
    default:
      return state
  }
}
